import { useAuth0 } from '@auth0/auth0-react'

export type Role = 'super_admin' | 'gym_owner' | 'gym_staff' | 'member'
/** Mirrors the `public.staff_role` enum and STAFF_ROLES in the Worker. */
export type StaffRole = 'front_desk' | 'route_setter' | 'trainer'

const ROLE_CLAIM = 'https://structuralclimbing.com/role'
const GYM_ID_CLAIM = 'https://structuralclimbing.com/gym_id'
export const STAFF_ROLE_CLAIM = 'https://structuralclimbing.com/staff_role'

export function useRole(): Role | null {
  const { user } = useAuth0()
  return (user?.[ROLE_CLAIM] as Role) ?? null
}

export function useGymId(): string | null {
  const { user } = useAuth0()
  return (user?.[GYM_ID_CLAIM] as string) ?? null
}

export function useStaffRole(): StaffRole | null {
  const { user } = useAuth0()
  return (user?.[STAFF_ROLE_CLAIM] as StaffRole) ?? null
}
